import { ModalManager } from "../../../../javascript/utils/modal-manager";
import { onDomReady } from "../../utils";

// If true, displaying the header links as a modal overlay
let linksAreInOverlay = false;

// =====================
// = Desktop Dropdowns =
// =====================

const openDropdown = (element) => {
  if (linksAreInOverlay) {
    return;
  }

  element.classList.add("em-open");
  element
    .querySelector(".em-header-links--dropdown-toggle")
    ?.setAttribute("aria-expanded", "true");
};

const closeDropdown = (element) => {
  if (linksAreInOverlay) {
    return;
  }

  element.classList.remove("em-open");
  element
    .querySelector(".em-header-links--dropdown-toggle")
    ?.setAttribute("aria-expanded", "false");
};

const closeAllDropdowns = () => {
  document.querySelectorAll(".em-header-links--item").forEach(closeDropdown);
};

const toggleDropdown = (button) => {
  const container = button.closest(".em-header-links--item");

  if (container.classList.contains("em-open")) {
    closeDropdown(container);
  } else {
    closeAllDropdowns();
    openDropdown(container);
  }
};

// ======================
// = Mobile Links Modal =
// ======================

const modalManager = ModalManager.getInstance();
let openerButton = null;

const closeMobileLinksMenu = (container) => {
  linksAreInOverlay = false;

  openerButton?.setAttribute("aria-expanded", "false");
  openerButton = null;
  container.classList.remove("em-open");
  setTimeout(() => {
    container.classList.remove("em-open--begin");
    document.getElementById("backdrop").classList.remove("em-checked");
    document.body.classList.remove("em-scroll-body");
  }, 300);
};

const openMobileLinksMenu = (button, container) => {
  linksAreInOverlay = true;

  openerButton = button;
  button.setAttribute("aria-expanded", "true");
  document.getElementById("backdrop").classList.add("em-checked");
  document.body.classList.add("em-scroll-body");
  container.classList.add("em-open--begin");
  setTimeout(() => {
    container.classList.add("em-open");
  }, 0);
  modalManager.openModal(container, () => {
    closeMobileLinksMenu(container);
  });
};

// Open the header links menu on mobile view
const toggleMobileLinksMenu = (button) => {
  const container = document.getElementById("em-header-links");

  if (container.classList.contains("em-open")) {
    closeMobileLinksMenu(button, container);
  }

  Slzr.Theme?.UserMenu?.hideMobileMenu();
  openMobileLinksMenu(button, container);
};

const handleCloseMobileLinksMenuClick = () => {
  const container = document.getElementById("em-header-links");
  closeMobileLinksMenu(container);
  modalManager.closeModal();
};

onDomReady(() => {
  window.addEventListener("resize", () => {
    if (window.innerWidth < 768) {
      closeAllDropdowns();
    } else if(linksAreInOverlay && window.innerWidth >= 768) {
      handleCloseMobileLinksMenuClick();
    }
  });

  document
    .querySelectorAll(".em-header-links--dropdown-toggle")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleDropdown(button);
      });
    });

  document
    .querySelectorAll(".em-header-links--mobile-toggle-button")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleMobileLinksMenu(button);
      });
    });

  document
    .querySelectorAll(".em-header-links--mobile-close-button")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        handleCloseMobileLinksMenuClick();
      });
    });
});
